"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Anchor = require("./Anchor.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // Component


var Anchor = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(_Anchor.StyledAnchor, _extends({
    ref: ref
  }, props), props.children);
});

exports.Anchor = Anchor;
Anchor.displayName = 'Anchor'; // Prop Types

Anchor.propTypes = {
  hasTextDecoration: _propTypes.default.bool,
  textColor: _propTypes.default.string,
  small: _propTypes.default.bool,
  size: _propTypes.default.string,
  display: _propTypes.default.string
};
Anchor.defaultProps = {
  hasTextDecoration: false,
  textColor: 'textPrimary',
  small: false,
  size: 'default',
  display: 'inline'
};